import { Injectable } from '@angular/core';
import { ApiService } from '../../core/http/api.service';
import { API_URL } from './api.constant';
import { MemoService } from '../../modules/memos/service/memo.service';
import { RESPONSE$ } from '../utils/constants';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  memoNotificationCount = 0;

  fetchNotification = new Subject<void>();
  fetchNotification$ = this.fetchNotification.asObservable();

  updateNotification = new Subject<
    (action: (item: any) => void) => void
  >();
  updateNotification$ = this.updateNotification.asObservable();

  constructor(
    private http: ApiService,
    private memoService: MemoService,
  ) {}

  updateNotificationCount() {
    this.fetchNotification.next();
    this.memoService.getMyTaskBadge().subscribe((memos: any) => {
      this.memoNotificationCount = memos.count;
    });
  }

  // Feature Notifications

  getAllNotification(params?: any): RESPONSE$ {
    return this.http.get(API_URL.notification, params);
  }

  markAllAsRead() {
    return this.http.post(API_URL.notification + 'read-all/', null);
  }

  updateIsRead(id: any) {
    return this.http.post(
      API_URL.notification + id + '/' + 'read' + '/',
      id,
    );
  }

  updateAnnRead(id: any) {
    return this.http.post(
      '/api/announcement/' + id + '/' + 'read/',
      null,
    );
  }
}

export interface MutedNotification {
  id?: number;
  disabled?: boolean;
  channel: string;
  action: string;
}

export interface NotificationList {
  group: string;
  group_en: string;
  actions: Actions[];
  tooltipEN?: string;
  tooltipTH?: string;
}

export interface Actions {
  label: string;
  value: string;
}

export interface NotificationChannel {
  name: string;
  label: string;
}

export interface newNotificationAction {
  label: string;
  value: string;
  tooltipTH?: string;
  tooltipEN?: string;
}
